import InjuryInfo from "./InjuryInfo";

export default InjuryInfo;